export default __webpack_public_path__ + "static/media/icon-coin-orai.4f22e679.svg";